import React, { Component } from 'react';
export default class Survey extends Component {
	constructor(props) {
		function item(id, title, options) {
			return { id, title, options, selected: options == undefined ? undefined : null };
		}
		super(props);
		this.state = {
			start: false,
			survey: [
				item('start', 'Welcome ot this survey'),
				item('vegetarian', 'Are you the Vegeterain?', ['Yes', 'No']),
				item('vegan', 'Are you the Vegan?', ['Yes', 'No']),
				item('celiac', 'Are you the Celiac?', ['Yes', 'No']),
				item('peanuts', 'are you the peanuts?', ['Yes', 'No']),
				item('time', 'Do you have time to prep or cook?', ['Yes', 'No']),
				item('budget', 'Please enter your budget', []),
				item('end', 'Thanks for taking the survey'),
			],
			index: 0,
		};
	}
	0;
	getCurrentSurvey = () => this.state.survey[this.state.index];
	renderQuestion = () => {
		const item = this.getCurrentSurvey();
		const updateButton = x => {
			let survey = this.state.survey;
			survey[this.state.index].selected = x;
			this.setState({ survey, index: this.state.index + 1 });
		};
		const renderEndSlide = () => {
			return this.state.survey.map(item => {
				if (item.id !== 'start' && item.id !== 'end') {
					return (
						<div>
							{item.id} : {item.selected || ''}
						</div>
					);
				}
			});
		};
		function renderOptions() {
			if (item.id == 'end') {
				return <div>{renderEndSlide()}</div>;
			}
			if (item.options == undefined) {
				return;
			}
			return item.options.map(item => (
				<div className="ui orange button" onClick={() => updateButton(item)} key={item}>
					<div>{item}</div>
				</div>
			));
		}
		return (
			<div className="surveyQ">
				<div className="surveyQ_title">{this.state.survey[this.state.index].title}</div>
				<div className="surveyA_con">{renderOptions()}</div>
			</div>
		);
	};
	renderArrow = () => {
		const renderLeftArrow = () => {
			if (this.state.index != 1) {
				return (
					<div
						className="survey_arrow survey_arrowL"
						onClick={() => {
							this.setState({ index: this.state.index - 1 });
						}}
					>
						{'<'}
					</div>
				);
			}
		};
		const renderRightArrow = () => {
			const cur = this.getCurrentSurvey();
			if (this.state.index != this.state.survey.length - 1 && cur.selected !== null) {
				return (
					<div
						className="survey_arrow survey_arrowR"
						onClick={() => {
							this.setState({ index: this.state.index + 1 });
						}}
					>
						<div>></div>
					</div>
				);
			}
		};
		return (
			<div className="survey_arrow-con">
				{renderLeftArrow()}
				{renderRightArrow()}
			</div>
		);
	};

	DoSurvey = () => {
		if (this.state.start) {
			const cur = this.getCurrentSurvey();
			let renderList = type => {
				if (type == 'end') {
					let storage = [];
					for (var i = 1; i < this.state.survey.length - 1; i++) {
						storage.push({ id: this.state.survey[i].id, value: this.state.survey[i].selected });
					}
					console.log('!!!');
					return (
						<button
							className="ui button"
							onClick={() => {
								console.log('!!!xd');
								this.props.Submit(storage);
							}}
						>
							Generate Results
						</button>
					);
				} else if (type == 'budget') {
					return (
						<div class="ui action input">
							<input
								type="text"
								value={this.state.survey[this.state.index].selected}
								onChange={e => {
									let survey = this.state.survey;
									survey[this.state.index].selected = e.target.value;
									this.setState({ survey });
								}}
								placeholder="Enter Your Budget"
							/>
							<button
								class="ui button"
								onClick={() => {
									let tt = parseFloat(this.state.survey[this.state.index].selected);
									if (!isNaN(tt)) {
										this.setState({ index: this.state.index + 1 });
									}
								}}
							>
								Search
							</button>
						</div>
					);
				}
				return cur.options.map(item => (
					<button
						onClick={() => {
							let survey = this.state.survey;
							survey[this.state.index].selected = item;
							this.setState({ survey, index: this.state.index + 1 });
						}}
						className="ui button suAa"
					>
						{item}
					</button>
				));
			};
			let renderTitle = cur => {
				if (cur.id == 'end') {
					return (
						<div>
							<div>{cur.title}</div>
							{this.state.survey.map(item => {
								if (item.id != 'end' && item.id != 'start') {
									return (
										<div>
											{item.id}:{item.selected}
										</div>
									);
								}
							})}
						</div>
					);
				}
				return cur.title;
			};
			return (
				<div className="su">
					<div className="suQA">
						<div className="suQ">{renderTitle(cur)}</div>
						<div className="suA">{renderList(cur.id)}</div>
					</div>
				</div>
			);
		}
	};

	render() {
		const Front = ` ${this.state.start ? 'surveyFrontActive' : ''} surveyFront`;
		const Back = `${this.state.start ? 'hide' : ''} surveyBack`;
		const buttonFront = `${this.state.start ? 'hide' : ''} ui inverted button `;
		const imgFront = ` ${this.state.start ? 'hide' : ''} surveyFront_img`;

		return (
			// <div className="survey">
			// 	{this.renderQuestion()}
			// 	{this.renderArrow()}
			// </div>
			<div className="survey">
				<div className={Front}>
					{this.DoSurvey()}
					<div className={imgFront}>
						<img src={require('../images/groceries.png')}></img>
					</div>
					<div
						className={buttonFront}
						onClick={() => {
							this.setState({ start: true, index: 1 });
							// console.log('!!!!!');
						}}
					>
						Get Started!
					</div>
				</div>
				<div className={Back}>
					GoCeries is a meal planning app for people that need specific accommodations on recipes within a set
					budget, as well as the average consumer to find something to eat when they don’t know what to make.
					The app has a niche for all food lovers to fall into.
				</div>
			</div>
		);
	}
}
